// extracted by mini-css-extract-plugin
export default {"referralTab":"invitation-tabs_referralTab__pR6xg","referralTabActive":"invitation-tabs_referralTabActive__LQSLq"};